<template>
  <div class="header">
    <div class="header-content">
      <h1 class="header-content--title">Where is my country?</h1>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style>
.header {
  width: 100%;
  height: 80px;
  background-color: #fff;
  box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.75);
  position: sticky;
  top: 0;
}
.header-content {
  width: 90%;
  height: 80px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.header-content--title{
  font-size: 2rem;
}
</style>